const updateProductsLoading = (state, { payload: { loading } }) => {
	state.productsLoading = loading;
};

export default updateProductsLoading;
